import Vue from 'vue'
import {
  getSitesEditorModuleStateKey,
  transformUrl
  // mapObj
} from '@/utils/util'
import { axios } from '@/utils/request'
import globalUrl from '@/config/global'
// import {
//   sitesEditorFieldsMap
// } from './sitesEditor.const'

const state = {
  userId: '',
  moduleList: [],
  moduleListEbook: [],
  moduleId: '',
  cardId: ''
}

const getters = {
  // getModuleState: state => moduleProp => state[`${this.moduleProp.type}_${this.moduleProp._id}`] || {}
  getModuleState: state => moduleProp => state[`${this.moduleProp.itemType}_${this.moduleProp.id}`] || {}
  // addCurrentMenu: state => (menuList, currentMenu) => {
  // state[currentMenu] = state[menuList].length
  // return state[currentMenu]
  // }

  // getCurrentEdit: state => () => {
  //   return state[currentEdit]
  // }
}

const mutations = {
  update(state, payload) {
    for (const key in payload) {
      Vue.set(state, key, payload[key])
    }
  }
  // setNewCurrentEdit(state, currentEdit) {
  //   state.currentEdit = currentEdit
  // },
  // deleteMenuList(state, currentEdit) {
  //   console.log('currentEdit', currentEdit)
  //   state.menuList.splice(currentEdit.currentIndex, 1)
  // },
  // changCurrentMenu(state, index) {
  //   state.currentMenu = index
  // }
  // setModel(state, payload) {
  //   for (const key in payload) {
  //     Vue.set(state, key, payload[key])
  //   }
  //   // const { stateKey, data } = payload
  //   // Vue.set(state, stateKey, data)
  // }
}

const actions = {
  async fetchModule({ commit, state: { moduleId } }) {
    console.log(globalUrl)
    const params = {
      type: '2'
    }
    const sid = Vue.ls.get('moduleId')
    console.log('localStorage', Vue.ls.get('moduleId'))
    const rz = await axios.get(globalUrl.getMoudles, { params })
    commit('update', { moduleList: rz, moduleId: sid })
    // console.log('state', state)
    // state.moduleList = result
    // return result
    // commit('update', { moduleList: result })
  },
  async fetchEbookModule({ commit, state: { moduleType, currentEbookModule, moduleListEbook } }) {
    console.log(globalUrl)
    const sid = Vue.ls.get('currentEbookModule')
    const type = Vue.ls.get('moduleType')
    const params = {
      type: 10
    }
    const rz = await axios.get(globalUrl.getEbookMoudles, { params })
    commit('update', { moduleListEbook: rz, moduleType: type, currentEbookModule: sid })
  },
  async getModuleData({ commit, dispatch }, moduleProp) {
    const methodName = `get${moduleProp.itemType}`
    if (!actions[methodName]) {
      console.error(`${methodName} not exists`)
      return
    }
    const rz = await dispatch(methodName, {
      moduleProp
    })
    const data = {}
    const stateKey = getSitesEditorModuleStateKey('item', moduleProp)
    data[stateKey] = rz
    commit('update', data)
  },
  async updateModuleData({ commit, dispatch }, payload) {
    const { moduleProp } = payload
    const methodName = `update${moduleProp.itemType}`
    if (!actions[methodName]) {
      console.error(`${methodName} not exists`)
      return
    }
    const rz = await dispatch(methodName, payload)
    const data = {}
    const stateKey = getSitesEditorModuleStateKey('item', moduleProp)
    data[stateKey] = rz
    commit('update', data)
  },
  async getBizCard({ state: { userId } }, { moduleProp }) {
    // const rz = await axios.get(`/org/orgTeacherInfo?userId=${userId}`)
    const rz = await axios.get(`/b/material/web/home/org/orgTeacherInfo?itemId=${moduleProp.id}`)
    // const item = mapObj(sitesEditorFieldsMap[moduleProp.itemType], rz)
    return rz
  },
  async updateBizCard({ state: { userId } }, { moduleProp, moduleData }) {
    moduleData.itemId = moduleProp.id
    const rz = await axios.post(`/b/material/web/home/org/updateTeacherInfo`, moduleData)
    return rz
    // mapObj(sitesEditorFieldsMap[moduleProp.itemType], rz)
  },
  /**
   * 导师简介
   */
  async getTeacherIntro({ state: { userId } }, { moduleProp }) {
    // const rz = await axios.get(`/org/orgTeacherInfo?userId=${userId}`)
    const rz = await axios.get(`/b/material/web/home/org/orgTeacherIntro?itemId=${moduleProp.id}`)
    // const item = mapObj(sitesEditorFieldsMap[moduleProp.itemType], rz)
    return rz
  },
  async updateTeacherIntro({ state: { userId } }, { moduleProp, moduleData }) {
    // const item = mapObj(sitesEditorFieldsMap[moduleProp.itemType], moduleData, true)
    moduleData.itemId = moduleProp.id
    // const rz = await axios.post(`/org/orgTeacherInfo/edit?userId=${userId}`, item)
    const rz = await axios.post(`/b/material/web/home/org/updateTeacherInfo`, moduleData)
    // return mapObj(sitesEditorFieldsMap[moduleProp.itemType], rz)
    return rz
  },
  /**
   * 获取推荐活动数据
   */
  async getRecommend({ state: { userId } }, { moduleProp }) {
    const rz = await axios.get(`/b/material/web/home/org/getProductListByReldIds?itemId=${moduleProp.id}`)
    // const item = mapObj(sitesEditorFieldsMap[moduleProp.itemType], rz)
    return rz
  },
  async updateRecommend({ state: { userId } }, { moduleProp, moduleData }) {
    // const item = mapObj(sitesEditorFieldsMap[moduleProp.itemType], moduleData, true)
    const rz = await axios.get(`/b/material/web/home/org/getProductListByReldIds?itemId=${moduleProp.id}`)
    // return mapObj(sitesEditorFieldsMap[moduleProp.itemType], rz)
    return rz
  },

  /**
   * getOrgIntro
   */
  async getOrgIntro({ state: { userId } }, { moduleProp }) {
    const rz = await axios.get(`/b/material/web/home/org/getOrgInfo?itemId=${moduleProp.id}`)
    // const item = mapObj(sitesEditorFieldsMap[moduleProp.itemType], rz)
    // const item = mapObj(sitesEditorFieldsMap[moduleProp.itemType], rz)
    return rz
  },
  async updateOrgIntro({ state: { userId } }, { moduleProp, moduleData }) {
    // const item = mapObj(sitesEditorFieldsMap[moduleProp.itemType], moduleData, true)
    moduleData.itemId = moduleProp.id
    const rz = await axios.post(`/b/material/web/home/org/updateOrgInfo`, moduleData)
    return rz
    // return mapObj(sitesEditorFieldsMap[moduleProp.itemType], rz)
  },
  /**
   * 获取机构动态
   */
  async getOrgDynamic({ state: { userId } }, { moduleProp }) {
    const rz = await axios.get(`/b/material/web/home/org/getDynamicPage?itemId=${moduleProp.id}&size=10&current=1`)
    // const item = mapObj(sitesEditorFieldsMap[moduleProp.itemType], rz)
    return rz
  },
  async updateOrgDynamic({ state: { userId } }, { moduleProp, moduleData }) {
    // const item = mapObj(sitesEditorFieldsMap[moduleProp.itemType], moduleData, true)
    const rz = await axios.get(`/b/material/web/home/org/getDynamicPage?itemId=${moduleProp.id}&size=10&current=1`)
    return rz
    // return mapObj(sitesEditorFieldsMap[moduleProp.itemType], rz)
  },

  /**
   * 获取Menu
   */
  async getRead({ state: { userId } }, { moduleProp }) {
    // const rz = await axios.get(`/s/getMenu?userId=${userId}`, {
    //   matType: 1
    // })
    // rz.list = await axios.get(`/s/material/group?matType=1`)

    const rz = await axios.get(`/b/material/web/home/readCardItems?cardType=2`)
    // const item = mapObj(sitesEditorFieldsMap[moduleProp.type], rz)
    return rz
  },
  /**
   * 更新Menu
   */
  async updateRead({ state: { userId, moduleId, moduleList } }, { moduleProp, moduleData }) {
    const params = {
      pReadCardVOS: moduleData,
      sid: Vue.ls.get('moduleId')
    }
    const rz = await axios.post(`/p/security/comCardItem/readCardItems/saveAll`, params)
    return rz
  },
  /**
   * 获取轮播图
   */
  async getBanner({ state: { userId } }, { moduleProp }) {
    // const rz = await axios.get(`/org/orgTeacherInfo?userId=${userId}`)
    // const data ={

    // }
    const rz = await axios.get(`/s/marketing/itemBanner/getBannerList?itemId=${moduleProp.id}`)
    for (const v of rz) {
      if (v.type === '2009') {
        v.selectName = v.relation
      }
    }
    // const item = mapObj(sitesEditorFieldsMap[moduleProp.itemType], rz)
    return rz
  },
  async updateBanner({ state: { userId } }, { moduleProp, moduleData }) {
    // for (const v of moduleData) {
    //   v.itemId = moduleProp.id
    // }
    const tmp = {
      itemId: moduleProp.id,
      itemBanners: []
    }
    for (const v of moduleData) {
      tmp.itemBanners.push({
        itemId: moduleProp.id,
        relation: v.relation,
        type: v.type,
        imgUrl: v.imgUrl,
        selectName: v.selectName
      })
    }
    // moduleData.itemId = moduleProp.id
    const rz = await axios.post(`/s/marketing/itemBanner/saveAll`, tmp)
    for (const v of rz) {
      if (v.type === '2009') {
        v.selectName = v.relation
      }
    }
    return rz
  },
   /**
   * 获取Menu
   */
  async getNavigation({ state: { userId, cardId } }, { moduleProp }) {
    // const rz = await axios.get(`/s/getMenu?userId=${userId}`, {
    //   matType: 1
    // })
    // rz.list = await axios.get(`/s/material/group?matType=1`)

    const rz = await axios.get(`/p/security/comCardItemBook/getAllReadCardItems?itemId=` + cardId)
    return rz
  },
  /**
   * 更新Menu
   */
  async updateNavigation({ state: { userId, moduleId, moduleList } }, { moduleProp, moduleData }) {
    const rz = await axios.post(`/p/security/comCardItemBook/saveAll`, moduleData.eBook)
    return rz
  },
   /**
   * 获取轮播图
   */
  async getEbookBanner({ state: { userId } }, { moduleProp }) {
    // const rz = await axios.get(`/org/orgTeacherInfo?userId=${userId}`)
    // const data ={

    // }
    const rz = await axios.get(`/p/security/comCardItemBanner/getBannerList?itemId=${moduleProp.id}`)
    for (const v of rz) {
      if (v.type === '2009') {
        v.selectName = v.relation
      }
    }
    // const item = mapObj(sitesEditorFieldsMap[moduleProp.itemType], rz)
    return rz
  },
  async updateEbookBanner({ state: { userId } }, { moduleProp, moduleData }) {
    // for (const v of moduleData) {
    //   v.itemId = moduleProp.id
    // }
    const tmp = {
      itemId: moduleProp.id,
      itemBanners: []
    }
    for (const v of moduleData) {
      tmp.itemBanners.push({
        itemId: moduleProp.id,
        relation: v.relation,
        type: v.type,
        imgUrl: v.imgUrl,
        selectName: v.selectName
      })
    }
    // moduleData.itemId = moduleProp.id
    const rz = await axios.post(`/p/security/comCardItemBanner/saveAll`, tmp)
    for (const v of rz) {
      if (v.type === '2009') {
        v.selectName = v.relation
      }
    }
    return rz
  },
  /**
   * 获取优惠券列表
   */
  async getCoupon({ state: { userId } }, { moduleProp }) {
    // const rz = await axios.get(`/org/orgTeacherInfo?userId=${userId}`)
    const rz = await axios.get(`/s/marketing/itemCoupon/getCouponList/${moduleProp.id}`)
    // const item = mapObj(sitesEditorFieldsMap[moduleProp.itemType], rz)
    return rz
  },
  async updateCoupon({ state: { userId } }, { moduleProp, moduleData }) {
    if (!moduleData) {
      moduleData = await axios.get(`/s/marketing/itemCoupon/getCouponList/${moduleProp.id}`)
      // return
    }
    const tmp = {
      itemId: moduleProp.id,
      itemCoupons: []
    }
    for (const v of moduleData) {
      tmp.itemCoupons.push({
        itemId: moduleProp.id,
        couponId: v.id,
        state: v.state
      })
    }
    const rz = await axios.post(`/s/marketing/itemCoupon/saveAll`, tmp)
    return rz
  },
  /**
   * 获取产品列表
   */
  async getProduct({ state: { userId } }, { moduleProp }) {
    // const rz = await axios.get(`/org/orgTeacherInfo?userId=${userId}`)
    const rz = await axios.get(`/s/marketing/itemCategory/getCategoryList?itemId=${moduleProp.id}`)
    // const item = mapObj(sitesEditorFieldsMap[moduleProp.itemType], rz)
    return rz
  },
  async updateProduct({ state: { userId } }, { moduleProp, moduleData }) {
    if (!moduleData) {
      moduleData = await axios.get(`/s/marketing/itemCategory/getCategoryList?itemId=${moduleProp.id}`)
    }
    // 深拷贝。否则直接用moduleData 是复杂数据类型，会有指针问题
    const moduleDataDep = _.cloneDeep(moduleData)
    for (const v of moduleDataDep) {
      v.itemId = moduleProp.id
      if (v.itemCategoryProducts && v.itemCategoryProducts.length > 0) {
        const arr = []
        for (const value of v.itemCategoryProducts) {
          arr.push({
            productId: value.productId,
            productType: value.productType
          })
        }
        v.itemCategoryProducts = arr
      }
    }
    // moduleData.itemId = moduleProp.id
    await axios.post(`/s/marketing/itemCategoryProduct/saveAll`, moduleDataDep)
    const rz = await axios.get(`/s/marketing/itemCategory/getCategoryList?itemId=${moduleProp.id}`)
    return rz
  },
  async getButtonList({ state: { userId } }, { moduleProp }) {
    const rz = await axios.get(`/s/marketing/mktComponentsButton/getButtons?fromComponentId=${moduleProp.id}`)
    return rz
  },
  async updateButtonList({ state: { userId } }, { moduleProp, moduleData }) {
    if (!moduleData) {
      moduleData = await axios.get(`/s/marketing/mktComponentsButton/getButtons?fromComponentId=${moduleProp.id}`)
    }
    const tmp = _.cloneDeep(moduleData)
    const arr = {
      title: tmp.title,
      mktComponentsButtonVOS: [],
      fromComponentId: moduleProp.id
    }
    // for(const of tmp){

    // }
    for (const v of tmp.mktComponentsButtonVOS) {
      arr.mktComponentsButtonVOS.push({
        title: v.title,
        fromComponentId: moduleProp.id,
        relationId: v.relationId
      })
    }
    // tmp.forEach(v => {})
    // moduleData.itemId = moduleProp.id
    const rz = await axios.post(`/s/marketing/mktComponentsButton/saveOrUpdateButtons`, arr)
    return rz
  },
  async getCover({ state: { userId } }, { moduleProp }) {
    const rz = await axios.get(`/s/marketing/mktComponentsPhoto/getComponentsPhoto?fromComponentId	=${moduleProp.id}`)
    return rz
  },
  async updateCover({ state: { userId } }, { moduleProp, moduleData }) {
    // moduleData.fromComponentId = moduleProp.id
    const tmp = {
      photoUrl: transformUrl(moduleData.photoUrl),
      fromComponentId: moduleProp.id
    }
    const rz = await axios.post(`/s/marketing/mktComponentsPhoto/saveOrUpdateComponentsPhoto`, tmp)
    return rz
  },
  async getCheckbox({ state: { userId } }, { moduleProp }) {
    const rz = await axios.get(`/s/marketing/mktComponentsOptions/getOptions?fromComponentId=${moduleProp.id}`)
    return rz
  },
  async updateCheckbox({ state: { userId } }, { moduleProp, moduleData }) {
    // moduleData.itemId = moduleProp.id
    const rz = await axios.post(`/s/marketing/mktComponentsOptions/saveOrUpdateOptions`, moduleData)
    return rz
  },
  async getMultilineText({ state: { userId } }, { moduleProp }) {
    const rz = await axios.get(`/s/marketing/mktComponentsText/getComponentsText?fromComponentId=${moduleProp.id}`)
    return rz
  },
  async updateMultilineText({ state: { userId } }, { moduleProp, moduleData }) {
    // moduleData.fromComponentId = moduleProp.id
    const rz = await axios.post(`/s/marketing/mktComponentsText/saveOrUpdateComponentsText`, moduleData)
    return rz
  },
  async getSingText({ state: { userId } }, { moduleProp }) {
    const rz = await axios.get(`/s/marketing/mktComponentsText/getComponentsText?fromComponentId=${moduleProp.id}`)
    return rz
  },
  async updateSingText({ state: { userId } }, { moduleProp, moduleData }) {
    // moduleData.fromComponentId = moduleProp.id
    const rz = await axios.post(`/s/marketing/mktComponentsText/saveOrUpdateComponentsText`, moduleData)
    return rz
  },
  async getRadio({ state: { userId } }, { moduleProp }) {
    const rz = await axios.get(`/s/marketing/mktComponentsOptions/getOptions?fromComponentId=${moduleProp.id}`)
    return rz
  },
  async updateRadio({ state: { userId } }, { moduleProp, moduleData }) {
    // moduleData.itemId = moduleProp.id
    const rz = await axios.post(`/s/marketing/mktComponentsOptions/saveOrUpdateOptions`, moduleData)
    return rz
  },
  async getSubmit({ state: { userId } }, { moduleProp }) {
    const rz = await axios.get(`/s/marketing/mktComponentsButton/getButtons?fromComponentId=${moduleProp.id}`)
    if (rz.mktComponentsButtonVOS.length === 0) {
      rz.mktComponentsButtonVOS.push({
        title: '',
        relationId: '',
        matArtName: ''
      })
    }
    return rz
  },
  async updateSubmit({ state: { userId } }, { moduleProp, moduleData }) {
    // moduleData.itemId = moduleProp.id
    if (!moduleData) {
      moduleData = await axios.get(`/s/marketing/mktComponentsButton/getButtons?fromComponentId=${moduleProp.id}`)
    }
    const tmp = _.cloneDeep(moduleData)
    const arr = {
      title: tmp.title,
      mktComponentsButtonVOS: [],
      fromComponentId: moduleProp.id
    }
    // for(const of tmp){

    // }
    for (const v of tmp.mktComponentsButtonVOS) {
      arr.mktComponentsButtonVOS.push({
        title: v.title,
        fromComponentId: moduleProp.id,
        relationId: v.relationId,
        relationType: moduleData.relationType ? moduleData.relationType : ''
      })
    }

    // moduleData.itemId = moduleProp.id
    const rz = await axios.post(`/s/marketing/mktComponentsButton/saveOrUpdateButtons`, arr)
    if (rz.mktComponentsButtonVOS.length === 0) {
      rz.mktComponentsButtonVOS.push({
        title: '',
        relationId: '',
        matArtName: ''
      })
    }
    return rz
  },
  async getTitle({ state: { userId } }, { moduleProp }) {
    const rz = await axios.get(`/s/marketing/mktComponentsTitle/getComponentsTitle?fromComponentId=${moduleProp.id}`)
    return rz
  },
  async updateTitle({ state: { userId } }, { moduleProp, moduleData }) {
    // moduleData.itemId = moduleProp.id
    const rz = await axios.post(`/s/marketing/mktComponentsTitle/saveOrUpdateComponentsTitle`, moduleData)
    return rz
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
